//https://www.npmjs.com/package/vue-msal#auth-options--required-
function getEnv() {
  let env = "local";
  if (typeof window !== "undefined") {
    if (
      window.location.hostname === "eosdevwebstorage.z6.web.core.windows.net"
    ) {
      env = "motius";
    } else if (window.location.hostname === "www.eosdevelopernetwork.net") {
      env = "eos";
    } else if (window.location.hostname === "dev.eosdevelopernetwork.net") {
      env = "eos-dev";
    }
  }
  // MSAL could not be stubbed via cypress, so here is a small workaround to get past the MSAL
  // in the e2e test. If we are in local environment and the environment is production
  // (the case for e2e), then we return as mode test.
  if ("local" === env && "production" === process.env.NODE_ENV.toLowerCase()) {
    return "test";
  }

  // running locally, by default use the eos dev-environment
  return env;
}
const msalConfigMotius = {
  auth: {
    clientId: "939231bd-8219-4aae-92c7-e18c505ac4cf",
    redirectUri: "https://eosdevwebstorage.z6.web.core.windows.net/"
  },
  request: {
    scopes: [
      "openid",
      "profile",
      "email",
      "User.Read",
      "api://939231bd-8219-4aae-92c7-e18c505ac4cf/access_as_user"
    ]
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: true // Set this to "true" if you are having issues on IE11 or Edge
  }
};

const msalConfigEOS = {
  auth: {
    validateAuthority: false, //Validate the issuer of tokens. For B2C applications, since the authority value is known and can be different per policy, the authority validation will not work and has to be set to false.
    authority: "https://login.microsoftonline.com/common/",
    clientId: "e45f48a5-b00e-4e9a-9ad2-cf8996716b58",
    redirectUri: "https://www.eosdevelopernetwork.net/"
  },
  request: {
    scopes: [
      "openid",
      "profile",
      "email",
      "User.Read",
      "api://e45f48a5-b00e-4e9a-9ad2-cf8996716b58/access_as_user"
    ]
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: true // Set this to "true" if you are having issues on IE11 or Edge
  }
};

const msalConfigEOSDev = {
  auth: {
    validateAuthority: false, //Validate the issuer of tokens. For B2C applications, since the authority value is known and can be different per policy, the authority validation will not work and has to be set to false.
    authority: "https://login.microsoftonline.com/common/",
    clientId: "58d16366-0da0-48c8-aa60-61b56282362d",
    redirectUri: "https://dev.eosdevelopernetwork.net/"
  },
  request: {
    scopes: [
      "openid",
      "profile",
      "email",
      "User.Read",
      "api://58d16366-0da0-48c8-aa60-61b56282362d/access_as_user"
    ]
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: true // Set this to "true" if you are having issues on IE11 or Edge
  }
};

const msalConfigEOSDevLocal = {
  auth: {
    validateAuthority: false, //Validate the issuer of tokens. For B2C applications, since the authority value is known and can be different per policy, the authority validation will not work and has to be set to false.
    authority: "https://login.microsoftonline.com/common/",
    clientId: "58d16366-0da0-48c8-aa60-61b56282362d",
    redirectUri: "http://localhost:8080"
  },
  request: {
    scopes: [
      "openid",
      "profile",
      "email",
      "User.Read",
      "api://58d16366-0da0-48c8-aa60-61b56282362d/access_as_user"
    ]
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: true
  }
};

const tokenRequestMotius = {
  scopes: ["api://939231bd-8219-4aae-92c7-e18c505ac4cf/access_as_user"]
};

const tokenRequestEOS = {
  scopes: ["api://e45f48a5-b00e-4e9a-9ad2-cf8996716b58/access_as_user"]
};

const tokenRequestEOSDev = {
  scopes: ["api://58d16366-0da0-48c8-aa60-61b56282362d/access_as_user"]
};

function getMsalConfig() {
  console.log("Msal Config is " + getEnv());
  switch (getEnv().toLowerCase()) {
    case "motius":
      return msalConfigMotius;
    case "eos":
      return msalConfigEOS;
    case "eos-dev":
      return msalConfigEOSDev;
    default:
      return msalConfigEOSDevLocal;
  }
}

function getTokenRequest() {
  switch (getEnv().toLowerCase()) {
    case "motius":
      return tokenRequestMotius;
    case "eos":
      return tokenRequestEOS;
    case "eos-dev":
      return tokenRequestEOSDev;
    default:
      return tokenRequestEOSDev;
  }
}

function getBaseURL() {
  switch (getEnv().toLowerCase()) {
    case "motius":
      return "https://api.dev-digitaltwin.com/v1/";
    case "eos":
      return "https://api.eosdevelopernetwork.net/v1/";
    case "eos-dev":
      return "https://eosdigitaltwinbackenddev.azurewebsites.net/v1/"; //https://api.dev.eosdevelopernetwork.net/v1/";
    default:
      // return "https://f922b193375d.ngrok.io/v1/"; // switch with below if you don't have the backend running locally
      return "https://eosdigitaltwinbackenddev.azurewebsites.net/v1/";
  }
}

function getReactAdminURL() {
  switch (getEnv().toLowerCase()) {
    case "motius":
      return "https://eosdevwebstorageadmin.z6.web.core.windows.net/";
    case "eos":
      return "https://admin.eosdevelopernetwork.net/";
    case "eos-dev":
      return "https://admin.dev.eosdevelopernetwork.net/";
    default:
      return "https://admin.dev.eosdevelopernetwork.net/";
  }
}

export const REACT_ADMIN_URL = getReactAdminURL();

export const msalEnv = getEnv();
export const msalConfig = getMsalConfig();
export const tokenRequest = getTokenRequest();
export const baseAPIURL = getBaseURL();
